import { createApp } from "vue";
import i18n from "./i18n";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/css/style.css";
import VueSweetalert2 from 'vue-sweetalert2';
import VueAwesomePaginate from "vue-awesome-paginate";
import VueQRCodeComponent from 'vue-qrcode-component';
import Flicking from "@egjs/vue3-flicking";
import "@egjs/vue3-flicking/dist/flicking.css";

// Import and setup axios interceptors for language support
import setupAxiosInterceptors from './services/axios-interceptors';

// Import migration utility
import { migrateAuthFromLocalStorage } from './utils/minimalMigration';

// Make testing utilities available globally in development
if (process.env.NODE_ENV === 'development') {
  // Add utilities after a short delay to avoid blocking app startup
  setTimeout(() => {
    import('./utils/authTesting').then(authTesting => {
      window.authTest = authTesting.default;
    }).catch(() => {/* Silent fail in production */});
    
    import('./utils/simpleMigrationTest').then(migrationTest => {
      window.testMigration = migrationTest.default;
    }).catch(() => {/* Silent fail in production */});
    
    import('./utils/storageDiagnostic').then(diagnostic => {
      window.diagnoseTool = diagnostic.default;
    }).catch(() => {/* Silent fail in production */});
    
    import('./utils/languageUtils').then(langUtils => {
      window.getCurrentLang = langUtils.getCurrentLanguage;
      window.setCurrentLang = langUtils.setCurrentLanguage;
    }).catch(() => {/* Silent fail in production */});
  }, 1000);
}

const options = {
  confirmButtonColor: '#1a418c',
  cancelButtonColor: '#ff7674',
};

import 'sweetalert2/dist/sweetalert2.min.css';
import { FontAwesomeIcon } from './plugins/font-awesome'
import Toaster from "@incuca/vue3-toaster";
import "vue-awesome-paginate/dist/style.css";
import VueApexCharts from 'vue3-apexcharts'

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken } from 'firebase/messaging';

const app = createApp(App)
  .use(router)
  .use(VueSweetalert2, options)
  .use(Toaster)
  .use(store)
  .use(VueAwesomePaginate)
  .use(VueApexCharts)
  .use(i18n)
  .component("font-awesome-icon", FontAwesomeIcon)
  .component('qr-code', VueQRCodeComponent)
  .component("Flicking", Flicking);

// Setup axios interceptors for automatic language parameter inclusion
setupAxiosInterceptors();

// Configure Vue to suppress ion-icon warnings
app.config.warnHandler = (msg) => {
  // Suppress specific ion-icon warnings in development
  if (process.env.NODE_ENV === 'development' && 
     (msg.includes('ion-icon') || msg.includes('Failed to resolve component: ion-icon'))) {
    return;
  }
  // In production, suppress all warnings for cleaner console
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  console.warn(msg);
};

// Configure global properties
app.config.globalProperties.$ionicons = true;

// Run migration from localStorage to cookies after DOM is ready
app.mount("#app");

// Run migration after app is mounted
setTimeout(() => {
  try {
    const migrationResult = migrateAuthFromLocalStorage();
    // Only log in development
    if (process.env.NODE_ENV === 'development' && migrationResult.success) {
      if (migrationResult.migratedItems && migrationResult.migratedItems.length > 0) {
        console.log('Migration completed:', migrationResult.message);
      }
    }
  } catch (error) {
    // Silent fail in production
    if (process.env.NODE_ENV === 'development') {
      console.error('Migration error:', error);
    }
  }
}, 100); // Small delay to ensure everything is loaded


var firebaseConfig = {
  apiKey: "AIzaSyB5nYEPnM4WP1xsRMykZWFBV905GS1qauY",
  authDomain: "wisdom-guide-dev.firebaseapp.com",
  projectId: "wisdom-guide-dev",
  storageBucket: "wisdom-guide-dev.appspot.com",
  messagingSenderId: "1060001451485",
  appId: "1:1060001451485:web:be5924b0e7ee1efbdf7a34",
  measurementId: "G-LNVG6KJ125"
}

const firebaseApp = initializeApp(firebaseConfig); // Initialize Firebase
const messaging = getMessaging(firebaseApp); // Initialize messaging

// Explicitly register the messaging service worker ourselves and hand the registration
// straight to getToken() — letting Firebase auto-register it internally (the previous
// getToken(messaging) call with no registration) raced PushManager.subscribe() against the
// worker still being in "installing" state, aborting with "no active Service Worker". Scoped
// to /firebase-cloud-messaging-push-scope (Firebase's own default) rather than root, so it
// doesn't fight the app's separate root-scoped PWA service-worker.js for control of the page.
// NOTE: navigator.serviceWorker.ready is deliberately NOT used here — it resolves to whichever
// worker controls the page (the root-scoped PWA one), not this non-controlling, custom-scoped
// registration.
function waitForServiceWorkerActive(registration) {
  if (registration.active) return Promise.resolve(registration);
  const worker = registration.installing || registration.waiting;
  if (!worker) return Promise.resolve(registration);
  return new Promise((resolve) => {
    worker.addEventListener('statechange', function onStateChange() {
      if (worker.state === 'activated') {
        worker.removeEventListener('statechange', onStateChange);
        resolve(registration);
      }
    });
  });
}

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js', { scope: '/firebase-cloud-messaging-push-scope' })
    .then((registration) => waitForServiceWorkerActive(registration))
    .then((registration) => getToken(messaging, { serviceWorkerRegistration: registration }))
    .then(token => {
      if (token) {
        localStorage.setItem('fcm', token);
        console.log('FCM Token:', token);
      } else {
        console.log('Token not available');
      }
    })
    .catch(error => {
      console.error('Error getting FCM token:', error);
    });
}

// Notification.requestPermission()
//   .then(permission => {
//     if (permission === 'granted') {
//       return getToken(messaging);
//     } else {
//       console.log('Notification permission denied');
//       return null;
//     }
//   })
//   .then(token => {
//     if (token) {
//       alert(token);
//       localStorage.setItem('fcm', token);
//       console.log('FCM Token:', token);
//     }
//   })
//   .catch(error => {
//     console.error('Error getting FCM token:', error);
//   });

// Register service worker and listen for updates (used by App.vue to show "Update available")
import './registerServiceWorker';
